import {useTranslation} from 'react-i18next'

import {WalletIcon} from '~/react/icons'
import {useProductEnabled} from './useProductEnabled'
import {usePermissions} from './usePermissions'

export const useSideNavLinks = () => {
  const {t} = useTranslation('points')
  const {data, isLoading} = usePermissions()
  const {enabled} = useProductEnabled()

  const generalLinks = enabled
    ? [
        {
          disabled: false,
          visible: true,
          label: t('points:sideNav.generalLinks.dashboardShowLabel'),
          icon: <WalletIcon />,
          href: '/points',
        },
        {
          disabled: false,
          visible: true,
          label: t('points:sideNav.generalLinks.redemptionPartnersIndexLabel'),
          icon: <WalletIcon />,
          href: '/points/redemption_partners',
        },
      ]
    : []

  const settingsUnlocked = data?.screenAccess?.settingsScreen

  return {
    isLoading,
    generalLinks,
    settingsUnlocked,
  }
}
